<template>
  <div
    class="outreach-contact-recent-articles"
    :class="{
      'outreach-contact-recent-articles__hide-stats': hideStats,
    }"
  >
    <OutreachContactRecentArticlesStats
      v-model:filter="keywordFilter"
      :filters="streamFilters"
      :hide-stats="hideStats"
      :offset-height="offsetHeight"
      :sticky="sticky"
      :stream="currentStream"
      @update:range="updateRange"
      @update:stream-id="selectedStreamId = $event"
    />

    <OutreachContactRecentArticlesMentions
      :default-range="defaultRange"
      :fetching-service="fetchMentions"
      :hide-no-results-message="!hideStats"
      :scroll-target="scrollTarget"
      :stream="currentStream"
      :stream-filters="streamFilters"
    />
  </div>
</template>

<script setup>
import { computed, onBeforeMount, ref } from "vue";

import DateRange from "shared/helpers/DateRange";
import StreamFilters from "shared/helpers/StreamFilters";
import { fetchMentions } from "shared/services/fetch/fetchMentions";
import { useStreamsStore } from "shared/stores/streams";

import OutreachContactRecentArticlesMentions from "./OutreachContactRecentArticlesMentions.vue";
import OutreachContactRecentArticlesStats from "./OutreachContactRecentArticlesStats.vue";

const props = defineProps({
  contact: {
    type: Object,
    required: true,
  },
  contactType: {
    type: String,
    default: "",
  },
  hideStats: {
    type: Boolean,
  },
  sticky: {
    type: Boolean,
  },
  offsetHeight: {
    type: Number,
    default: 0,
  },
  scrollTarget: {
    type: String,
    default: "",
  },
});

const streamsStore = useStreamsStore();
const { getStreamById } = streamsStore;

const streamFilters = ref({});
const selectedStreamId = ref(null);
const defaultRange = ref(DateRange.lastThirtyDays());
const keywordFilter = ref("");

const currentStream = computed({
  get() {
    if (selectedStreamId.value === null) {
      return {
        keywords: "",
        keyword: keywordFilter.value,
        media: ["Online", "Print"],
        online_content: true,
        print_content: true,
        influencer_id: props.contact.id,
        skipReload: true,
      };
    }

    return getStreamById(selectedStreamId.value);
  },
  set(stream) {
    selectedStreamId.value = stream.id;
  },
});

onBeforeMount(() => {
  streamFilters.value = new StreamFilters(currentStream.value, {
    dateRangeEnabled: true,
    range: DateRange.lastThirtyDays(),
    authors: [props.contact.name],
    media: ["Online", "Print"],
  });
});

function updateRange(range) {
  streamFilters.value = Object.assign(streamFilters.value.clone(), { range });
}
</script>

<style lang="scss" scoped>
.outreach-contact-recent-articles {
  width: 100%;

  :not(&__hide-stats) {
    :deep(.outreach-contact-stats) {
      margin-bottom: 16px;
      padding-top: 16px;
    }
  }

  &__hide-stats {
    :deep(.outreach-contact-stats) {
      border: none;
    }
  }
}
</style>
